
import { MANIFEST_MENU_ITEM } from "@/consts";
import ManifestTable from "@/components/barcodeSystem/manifest/ManifestTable.vue";
import ManifestFilters from "@/components/barcodeSystem/manifest/ManifestFilters.vue";
import ManifestActions from "@/components/barcodeSystem/manifest/ManifestActions.vue";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import ManifestModule from "@/store/modules/barcodeSystem/manifest";
import Component from "vue-class-component";
import permissions from "@/security/permissions";

const manifestModuleState = getModule(ManifestModule);

@Component({
  components: {
    ManifestTable,
    ManifestFilters,
    ManifestActions
  }
})
export default class Manifests extends Vue {
  showManifestFieldFilter: boolean = false;
  truckMenuStyle: string = "";
  MANIFEST_MENU_ITEM: any = MANIFEST_MENU_ITEM;

  get fields() {
    return manifestModuleState.fields;
  }

  async created() {
  }

  async loadMoreManifests() {
    await manifestModuleState.setLoading(true);
    await manifestModuleState.getManifests(null);
    await manifestModuleState.setLoading(false);
  }

  async onSort(s) {
    await manifestModuleState.setLoading(true);
    await manifestModuleState.applyListSort(s);
    await manifestModuleState.setLoading(false);
  }

  toggleChangeField(idx, hideShow) {
    manifestModuleState.toggleField({ idx: idx, value: !hideShow });
  }

  get menuItemsToDisplay() {
    return this.MANIFEST_MENU_ITEM.filter(
      x => (x.requiresPermission === undefined || this.hasPermission(x.requiresPermission)) && (x.requiresPermission != permissions.barcodeSystem.manifest.restore || this.allSelectedNotViewable())
    );
  }

  get dataRetreived() {
    if(manifestModuleState.data)
      return true;
    return false;
  }

  allSelectedNotViewable() {
    return manifestModuleState.getSelectedItemCount > 0 && manifestModuleState.getSelectedItems.every((x) => x.isViewable == false);
  }
}


